import { GetToken } from './GetAuthToken';

export enum Method {
    GET = 'GET',
    POST = 'POST',
    PUT = 'PUT',
    DELETE = 'DELETE',
    PATCH = 'PATCH',
}

interface Header {
    // TODO replace usage of this type with a better type that probably exists
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    [key: string]: any;
}

export const AuthRequest = async (
    url: string,
    method: Method,
    headers?: Header | null,
    body?: object | null,
    signal?: AbortSignal | null,
) => {
    //Get token and append to Authorization header before making request
    if (!headers) {
        headers = {};
    }

    const token = GetToken();
    headers.Authorization = `Bearer ${token}`;

    try {
        //Send request
        const res = await fetch(url, {
            method: method,
            mode: 'cors',
            headers: headers,
            body: body ? JSON.stringify(body) : null,
            signal,
        });

        return res;
    } catch (error) {
        if (error instanceof DOMException && error.name === 'AbortError') {
            // Fetch was aborted so silently ignore and return 'Client Closed Request' response
            // Status Code 499 is "commonly used in logs when the client has disconnected."
            // https://learn.microsoft.com/en-us/dotnet/api/microsoft.aspnetcore.http.statuscodes.status499clientclosedrequest?view=aspnetcore-9.0
            return new Response(JSON.stringify({}), {
                status: 499,
                statusText: 'Client Aborted Request',
            });
        }
        throw error;
    }
};
